export default __webpack_public_path__ + "static/integration-7c20f87de93cd7139b2e28005ed6f678.svg";